// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"00c7705f","220":"734dd961","501":"9a336f44","586":"20b5da13","716":"55fe61ad","923":"6489de68"}[chunkId] + ".chunk.js";
};